<template>
  <transition v-if="isAnimationEnabled" :name="isAnimationEnabled ? 'fade-in-up' : null">
    <router-view />
  </transition>
  <router-view v-else />
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  computed: {
    ...mapState({
      isAnimationEnabled: state => state.userSettingsLocal.isAnimationEnabled,
    }),
  },
};
</script>
